type Editable = { _editable?: unknown };

export function storyblokEditable(blok: Editable | null | undefined): Record<string, string> {
  if (!blok || typeof blok !== "object" || typeof blok._editable !== "string") return {};
  try {
    const options = JSON.parse(blok._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, ""));
    if (!options) return {};
    return {
      "data-blok-c": JSON.stringify(options),
      "data-blok-uid": `${options.id}-${options.uid}`,
    };
  } catch {
    return {};
  }
}
